<template src="../../templates/form/move-farm-form.pug" lang="pug"></template>

<script>
import Modal from './Modal.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { maxLength, maxValue, minLength, required } from 'vuelidate/lib/validators'
import _filter from 'lodash/filter'
export default {
    name: "MoveFarmForm",
    components: {
        Modal
    },
    props: ['animalToMove'],
    data() {
        return {
            animal: {}
        }
    },
    computed: {
        ...mapGetters([
                'selectedFarm',
                'allBuildings'
        ]),
        isFormValid() {
            return this.animal.building !== this.animalToMove.building
        }
    },
    created() {
        this.animal = {
            id: this.animalToMove.id,
            building: this.animalToMove.building,
            buckleNumber: this.animalToMove.buckleNumber
        }
    },
    methods: {
        ...mapActions(['moveAnimal']),
        close() {
            this.$router.go(-1)
        },
        submit() {
            if (this.isFormValid) {
                this.moveAnimal(this.animal)
                this.close()
            }
        }
    }
}
</script>

<style lang="sass">
@import '../../sass/mixin/color'
@import '../../sass/mixin/flex'

#move-farm-modal
    .modal-container
        .modal-header
            background-color: $dd-light-orange
            color: white
        .modal-body
            form
                input, input:focus, input:valid, .multiselect
                    border-left: 8px solid $dd-light-orange
                .select
                    @include flex-center
                    .form-select
                        width: 100%
                        height: 40px
                        background: url('/img/br_down.png') 96% no-repeat #fff
                        border-left: 8px solid $dd-light-orange
                        border-bottom: none
                        border-right: none
                        border-top: transparent
                        padding: 0.25em
                        font-size: 16px
                        font-weight: bold
                        -webkit-appearance: none
                        -moz-appearance: none
                        appearance: none

</style>